module.exports = __webpack_public_path__ + "img/googleAdsLogo.44db41d5.svg";